import { useIntegrationsStore } from '@modules/integrationsV2/store/integrationsStore';
import { Box, Grid, Typography } from '@mui/material';
import { IntegrationFormDataViewFragment } from 'generated/graphql';
import { capitalize } from 'lodash';
import { AddNewIntegrationDrawerContentCard } from './DrawerIntegrationCard';

interface AddNewIntegrationDrawerContainerProps {
  integrations: IntegrationFormDataViewFragment[];
  searchTerm: string;
}

export const AddNewIntegrationDrawerContainer = ({
  integrations,
  searchTerm,
}: AddNewIntegrationDrawerContainerProps) => {
  const integrationTypeFilterInDrawer = useIntegrationsStore(
    ({ view }) => view.integrationTypeFilterInDrawer,
  );

  const getNoIntegrationsFoundMessage = () => {
    if (searchTerm) {
      return 'No matches found';
    }
    if (integrationTypeFilterInDrawer === 'all') {
      return 'No integrations found';
    }
    return `No ${capitalize(integrationTypeFilterInDrawer)} integrations found`;
  };

  if (!integrations.length) {
    return (
      <Box
        position="absolute"
        left="50%"
        top="50%"
        sx={{ transform: 'translate(-50%,-50%)' }}
      >
        <Typography variant="body1">
          {getNoIntegrationsFoundMessage()}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        flexGrow: 1,
        overflow: 'auto',
        maxHeight: '77vh',
      }}
    >
      <Grid container spacing={2}>
        {integrations.map((integration) => {
          return (
            <Grid item lg={6} md={12} key={integration.channel.displayName}>
              <AddNewIntegrationDrawerContentCard integration={integration} />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};
